import { ReactElement } from 'react'
import { Download } from '@mui/icons-material'
import { Button } from '@mui/material'
import { GridToolbarContainer, useGridApiContext } from '@mui/x-data-grid-premium'

const FILE_NAME = 'Zuganker - manuelle Lasten und Kommentare'

const LostAnchorDataToolbar = (): ReactElement => {
  const apiRef = useGridApiContext()

  return (
    <GridToolbarContainer>
      <Button
        size="small"
        startIcon={<Download />}
        onClick={() => apiRef.current.exportDataAsCsv({ fileName: FILE_NAME, utf8WithBom: true })}
        data-cy="lost-anchor-data-export-csv"
      >
        CSV herunterladen
      </Button>
    </GridToolbarContainer>
  )
}

export default LostAnchorDataToolbar
